import React from 'react';

interface IProps {
    condition: boolean;
    wrapper: (children: React.ReactNode) => React.ReactNode;
    children: React.ReactNode;
}

// use this component to conditionally render the parent or only the children
const conditionalWrapper = (props: IProps) => {
    const {
        condition,
        wrapper,
        children
    } = props;

    return condition ?
        <>{wrapper(children)}</> :
        <>{children}</>;
};

export default conditionalWrapper;